'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var template = require('../../templates/css.ejs');

module.exports = Backbone.View.extend({
    tagName: 'style',
    className: 'view-css',
    events: {},

    /**
     * Render CSS View
     */
    render: function () {
        this.$el.html( template(this.model) );
        this.$el.attr( 'type', 'text/css' );

        $( 'head' ).append( this.$el );
        window.$el = this.$el;
    },
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/css.js